import { Modal as OriginalModal, ModalContent, ModalHeader, ModalClose, ModalBody, ModalFooter } from "./Modal";
var Modal = OriginalModal;
Modal.Content = ModalContent;
Modal.Header = ModalHeader;
Modal.Close = ModalClose;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
export default Modal;
